const MarketTableSkeleton = () => {
  return (
    <div className="flex overflow-hidden w-full justify-center mb-8">
      <div className="flex-1 overflow-x-auto whitespace-nowrap max-w-max">
        <table className="min-w-max bg-white text-sm text-gray-600">
          <thead className="bg-gray-100">
            <tr>
              <th className="text-center p-4">Market</th>
              <th className="text-center p-4">Price</th>
              <th className="text-center p-4">Volume(24h)</th>
              <th className="text-center p-4">24h %</th>
              <th className="text-center p-4">7d %</th>
              <th className="text-center p-4">30d %</th>
              <th className="text-center p-4">All %</th>
            </tr>
          </thead>
          <tbody>
            <tr key="1" className="border-b">
              <td className="p-4">0Lswap</td>
              <td className="p-4">
                <span className="opacity-0 animate-pulse bg-gray-200 text-gray-200 font-bold rounded-lg">
                  $0.000000
                </span>
              </td>
              <td className="p-4">
                <span className="opacity-0 animate-pulse bg-gray-200 text-gray-200 font-bold rounded-lg">
                  $00,000
                </span>
              </td>
              <td className="p-4">
                <span className="opacity-0 animate-pulse bg-gray-200 text-gray-200 font-bold rounded-lg">
                  00,00%
                </span>
              </td>
              <td className="p-4">
                <span className="opacity-0 animate-pulse bg-gray-200 text-gray-200 font-bold rounded-lg">
                  00,00%
                </span>
              </td>
              <td className="p-4">
                <span className="opacity-0 animate-pulse bg-gray-200 text-gray-200 font-bold rounded-lg">
                  00,00%
                </span>
              </td>
              <td className="p-4">
                <span className="opacity-0 animate-pulse bg-gray-200 text-gray-200 font-bold rounded-lg">
                  0000,00%
                </span>
              </td>
            </tr>
            <tr key="2" className="border-b">
              <td className="p-4">Osmosis</td>
              <td className="p-4">
                <span className="opacity-0 animate-pulse bg-gray-200 text-gray-200 font-bold rounded-lg">
                  $0.000000
                </span>
              </td>
              <td className="p-4">
                <span className="opacity-0 animate-pulse bg-gray-200 text-gray-200 font-bold rounded-lg">
                  $000,000
                </span>
              </td>
              <td className="p-4">
                <span className="opacity-0 animate-pulse bg-gray-200 text-gray-200 font-bold rounded-lg">
                  00,00%
                </span>
              </td>
              <td className="p-4">
                <span className="opacity-0 animate-pulse bg-gray-200 text-gray-200 font-bold rounded-lg">
                  00,00%
                </span>
              </td>
              <td className="p-4">
                <span className="opacity-0 animate-pulse bg-gray-200 text-gray-200 font-bold rounded-lg">
                  00,00%
                </span>
              </td>
              <td className="p-4">
                <span className="opacity-0 animate-pulse bg-gray-200 text-gray-200 font-bold rounded-lg">
                  0000,00%
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MarketTableSkeleton;
